import dayjs from 'dayjs';
import { DAMAGE_STATUS } from '../../../../constant/Safety/DamageReport/standardCodes';

const createInitialDamageDefaultValue = ({ nowDiv }) => {
  const now = dayjs();

  return {
    isNGLTruck: false,
    trk_no_auto_complete: undefined,
    trk_no_text: undefined,
    driver: undefined,
    status: DAMAGE_STATUS?.DAMAGED,
    trk_ordometer: undefined,
    trk_abs: false,
    trk_battery: false,
    trk_engine_light: false,
    trk_hoses: false,
    trk_windshield: false,
    trk_lights: false,
    trk_mirrors: false,
    trk_mudflap: false,
    trk_reflectors: false,
    trk_turn_indicators: false,
    trk_others: undefined,
    cont_no: undefined,
    cont_seal: undefined,
    isNGLChassis: false,
    ch_no_auto_complete: undefined,
    ch_no_text: undefined,
    ch_plate_no: undefined,
    ch_abs: false,
    ch_air_leak: false,
    ch_brake_chamber: false,
    ch_brakes: false,
    ch_hubcap: false,
    ch_lights: false,
    ch_landing_gear: false,
    ch_mudflap: false,
    ch_7_way_plug: false,
    ch_others: undefined,
    div: nowDiv,
    yard: '',
    yard_location: '',
    st_left_dmg: false,
    st_right_dmg: false,
    dt_lfo_dmg: false,
    dt_lfi_dmg: false,
    dt_rfo_dmg: false,
    dt_rfi_dmg: false,
    dt_lro_dmg: false,
    dt_lri_dmg: false,
    dt_rro_dmg: false,
    dt_rri_dmg: false,
    tct_lfo_orig: false,
    tct_lfo_dmg: false,
    tct_lfi_orig: false,
    tct_lfi_dmg: false,
    tct_rfo_orig: false,
    tct_rfo_dmg: false,
    tct_rfi_orig: false,
    tct_rfi_dmg: false,
    tct_lro_orig: false,
    tct_lro_dmg: false,
    tct_lri_orig: false,
    tct_lri_dmg: false,
    tct_rro_orig: false,
    tct_rro_dmg: false,
    tct_rri_orig: false,
    tct_rri_dmg: false,
    completed: false,
    created_by: undefined,
    created_date: undefined,
    updated_by: undefined,
    updated_date: undefined,
    report_date: now,
    report_time: now,
    photo: [],
  };
};

export default createInitialDamageDefaultValue;
